export * from './lib/store-consumption-detail-view';
